import { useNavigate, useSearchParams } from "react-router-dom";
import { getKakaoUser } from "../../../service";
import { useEffect } from "react";
import PolicyDataTransfer from "../../../components/modal/policyDataTransfer";
import { usePostSocialLogin } from "../../../features/auth/usePostSocialLogin";

const KakaoLoginCallback = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const code = searchParams.get("code");
    const { redirectPath, isPolicyModalOpen, finishLogin } = usePostSocialLogin();

    useEffect(() => {
        if (!code) {
            navigate('/login');
            return;
        }
        requestGetUser(code);
    }, [code]);

    const requestGetUser = async (code: string) => {
        try {
            await getKakaoUser(code)
            finishLogin();
        } catch (error) {
            console.error('error', error);
            navigate('/login')
        }

    }
    return <>
        <PolicyDataTransfer propsModalStatus={isPolicyModalOpen} beforeUrl={redirectPath} />
    </>
}
export default KakaoLoginCallback;
